export const BASE_URL = "http://64.227.158.138:8080/";
// export const BASE_URL = "http://192.168.0.91:8080/";
export const BASE_URL_MAIN = process.env.REACT_APP_LOGIN_MAIN_BASE_URL;
